function isString(value) {
    return Reflect.apply(Object.prototype.toString, value, []) === "[object String]";
}

export default isString;
